import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { w as waitForAnimation } from './index3.js';
import { c as createPopper, d as destroyPopper } from './index4.js';

const tooltipLabelCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-neutral-tooltip-message-bg-color);border-radius:.375rem;box-sizing:border-box;color:var(--jw-theme-neutral-tooltip-message-color);display:none;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;z-index:var(--jw-z-index-tooltips)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([open]){animation:uef7qtt .25s ease}@keyframes uef7qtt{0%{opacity:0}10%{opacity:0}to{opacity:1}}:host(:not([open])){animation:uef7qu0 .25s ease}@keyframes uef7qu0{0%{opacity:1}90%{opacity:0}to{opacity:0}}.inner{max-width:var(--jw-container-xs);min-width:2rem;padding:.5rem 1rem;position:relative;text-align:center;white-space:nowrap}.inner[data-chars]{white-space:normal;width:30ch}.arrow{height:12px;visibility:hidden;width:12px}.arrow,.arrow:before{background:var(--jw-theme-neutral-tooltip-message-bg-color);position:absolute}.arrow:before{content:\"\";inset:0;transform:rotate(45deg);visibility:visible}:host([data-popper-placement^=bottom]) .arrow,:host([data-popper-placement^=top]) .arrow{left:50%;transform:translateX(-50%)}:host([data-popper-placement^=top]) .arrow{bottom:-4px}:host([data-popper-placement^=bottom]) .arrow{top:-4px}:host([data-popper-placement^=left]) .arrow,:host([data-popper-placement^=right]) .arrow{top:50%;transform:translateY(-50%)}:host([data-popper-placement^=left]) .arrow{right:-4px}:host([data-popper-placement^=right]) .arrow{left:-4px}";
const WuiTooltipLabelStyle0 = tooltipLabelCss;

const WuiTooltipLabel = /*@__PURE__*/ proxyCustomElement(class WuiTooltipLabel extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
        this.placement = 'top';
        this.open = false;
        this.fixed = false;
    }
    componentDidLoad() {
        if (this.open) {
            this.show();
        }
    }
    componentWillUpdate() {
        if (this.open) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    async show() {
        const p = waitForAnimation(this.el, 'animation');
        this.popperInstance = createPopper(this.el, {
            placement: this.placement,
            stretch: 'min',
            offset: 16,
            strategy: this.fixed ? 'fixed' : 'absolute',
            modifiers: [['arrow', this.arrowElm]],
        });
        this.el.style.display = 'flex';
        await p;
    }
    async hide() {
        await waitForAnimation(this.el, 'animation');
        this.el.style.display = 'none';
        this.popperInstance = destroyPopper(this.popperInstance);
    }
    async disconnectedCallback() {
        if (this.open) {
            await this.hide();
        }
    }
    render() {
        return (h(Host, { key: '7d483aaa0248f55146d013f80dc56a78d5c2652d', role: "tooltip" }, h("div", { key: 'b550be3264115d51f3976502171a65d41611c540', class: "inner", "data-chars": this.label && this.label.length > 30 }, h("div", { key: 'c9837c27b2a3c4d52d62bf417a19463932851d43' }, this.label)), h("div", { key: '47f5c5cee06fe7d15487127399f97f929d83c18e', class: "arrow", "data-popper-arrow": true, ref: (el) => {
                this.arrowElm = el;
            } })));
    }
    get el() { return this; }
    static get style() { return WuiTooltipLabelStyle0; }
}, [1, "wui-tooltip-label", {
        "label": [1],
        "placement": [1],
        "open": [516],
        "fixed": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTooltipLabel);
            }
            break;
    } });
}
defineCustomElement();

export { WuiTooltipLabel as W, defineCustomElement as d };

//# sourceMappingURL=tooltip-label.js.map